import { faClose, faLink, faMotorcycle } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import { SIZE } from "../../../configuration/Sizes"
import THEME from "../../../configuration/Theme"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import InputField from "../../../components/InputField/InputField"
import { useState } from "react"
import { useSaveCourier } from "../../../hooks/Courier/useSaveCourier"
import { PopupHelpButton } from "../../../components/Help/PopupHelpButton"
import { useTranslation } from "react-i18next"

interface LinkCourierPupopProps {
  onClonse: () => any
  onSuccess?: () => any
}

export function LinkCourierPupop({ onClonse, onSuccess }: LinkCourierPupopProps) {
  const { t } = useTranslation("frontend")

  const [linkEmail, setLinkEmail] = useState("")

  const { handleTryCourierLinkAsync } = useSaveCourier()

  const handleLinkCourier = async (e: React.FormEvent) => {
    e.preventDefault()

    await handleTryCourierLinkAsync(linkEmail, () => {
      onClonse()

      onSuccess && onSuccess()
    })
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert1}>
            <TitlePageResponsiveIconSmall
              title={"Vincular Entregador"}
              icon={faMotorcycle}
              iconColor={THEME.colors.iconBGColor}
              children={
                <div className="flex items-center gap-2">
                  <PopupHelpButton
                    helpKey="pages.delivery.pupop.linkcourierpupop.1"
                    variant="global"
                    title={t("helpPopup:global.deliveryCourierLink.title")}
                    description={t("helpPopup:global.deliveryCourierLink.description")}
                    bullets={t("helpPopup:global.deliveryCourierLink.bullets", { returnObjects: true }) as string[]}
                  />

                  <ButtonIcon
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGCloseColor}
                    iconColor={THEME.colors.buttonFGCloseColor}
                    icon={faClose}
                    onClick={onClonse}
                    size="small"
                    descriptionKey="interactionDescriptions:pages.delivery.pupop.linkCourierPupop.button.onClonse"
                  />
                </div>
              }
            />

            <form onSubmit={handleLinkCourier} className="mt-2 space-y-4 p-1">
              <InputField
                required
                type="email"
                value={linkEmail}
                onChange={(e) => setLinkEmail(e.target.value)}
                icon={faLink}
                placeholder="email@entregador.com"
                descriptionKey="interactionDescriptions:pages.delivery.pupop.linkCourierPupop.input.emailEntregadorCom"
              />

              <div className={defaultStyle.divisionBar}></div>

              <Button
                typeButton="submit"
                type="primary"
                size="medium"
                label={"Vincular"}
                bgColor={THEME.colors.buttonBGSaveColor}
                descriptionKey="interactionDescriptions:pages.delivery.pupop.linkCourierPupop.button.vincular"
              />
            </form>
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
